<template>
  <div>
    <!-- 头部导航条 -->
    <div class="nav_wrap Categories">
      <nav>
        <!-- 左侧logo和导航 -->
        <div class="left_nav">
          <router-link class="nav_logo" :to="{ path: '/' }">
            <img src="../assets/img/logo.png" alt="" />
          </router-link>
          <div class="nav_font">
            <router-link :to="{ path: '/' }">
              <span
                :class="
                  active == 'index' || active == '' ? 'active' : 'nav_item'
                "
                style="font-size: 20px"
                >首页</span
              >
            </router-link>
            <el-popover
              placement="bottom-start"
              width="120"
              trigger="hover"
              style="
                display: inline-block;
                cursor: pointer;
                padding: 0px 30px;
                position: relative;
                top: 10px;
              "
              v-model="visible"
            >
              <p
                style="text-align: center; height: 35px; line-height: 35px;font-size: 16px;"
                @click="visible = !visible"
              >
                <router-link :to="{ name: 'ch_search' }">
                  <span :class="active == 'ch_search' ? 'active_' : 'nav_item_'"
                    >中文案例库</span
                  >
                </router-link>
              </p>
              <p
                style="text-align: center; height: 35px; line-height: 35px;font-size: 16px;"
                @click="visible = !visible"
              >
                <router-link :to="{ name: 'search' }">
                  <span :class="active == 'search' ? 'active_' : 'nav_item_'"
                    >外文案例库</span
                  >
                </router-link>
              </p>

              <span
                v-on:mouseover="aa"
                v-on:mouseout="removeActive"
                slot="reference"
                :class="
                  active == 'ch_search' || active == 'search'
                    ? 'active'
                    : 'nav_item'
                "
                style="position: relative; top: -9px; font-size: 20px"
                @click="visible = !visible"
              >
                案例库
              </span>
            </el-popover>

            <!-- <router-link :to="{path:'/project'}">
                            <span :class="active == 'project' ? 'active' : 'nav_item'" >项目管理</span>
                        </router-link> -->
            <!-- <router-link to="">
              <span
                @click="prompt"
                :class="active == 'project' ? 'active' : 'nav_item'"
                style="font-size:25px"
                >项目管理</span
              >
            </router-link> -->
          </div>
        </div>
        <!-- 中部搜索框 -->
        <!-- <div v-if="token && active == 'search'" class="middle_search">
                    <img style="width:26px" src="../assets/img/search.png" alt="" @click="commonSearch">
                    <el-input class="search_input" @input="inputValue" v-model="search_content" clearable placeholder="搜索" @keyup.enter.native="commonSearch"></el-input>
                </div> -->
        <!-- 右侧登录按钮和个人中心 -->
        <div class="right_personal">
          <el-button v-if="!token" class="login_btn" @click="goLogin"
            >登 录</el-button
          >
          <div v-else class="loginStatus">
            <!-- <img src="../assets/img/message.png" alt="" /> -->
            <!-- 机构登录 -->
            <div class="orgLogin" v-if="loginType == 1 || loginType == 2">
              <router-link
                target="_blank"
                :to="{ path: '/caseBase/journalList' }"
                ><el-button type="text" style="padding:0;margin:0px 30px 0 0;" class="go_journal">期刊列表</el-button></router-link
              >

              <div class="welcome">
                欢迎!<span style="margin: 0 ;color: #6160dc">{{ siteName }}</span>
              </div>
              <div class="line"></div>
              <el-dropdown @command="selectDropdown">
                <img style="width: 28px" src="../assets/img/user.png" alt="" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="register"
                    v-if="loginType == 1 || loginType == 2"
                    >个人用户注册</el-dropdown-item
                  >
                  <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 个人登录 -->
            <div v-else-if="loginType == 3" class="right_con">
              <router-link
                target="_blank"
                :to="{ path: '/caseBase/journalList' }"
                ><el-button type="text"  style="padding:0;margin:0px 30px 0 0;" class="go_journal"
                  >期刊列表</el-button
                ></router-link
              >
              <el-dropdown @command="selectDropdown">
                <div class="personal">
                  <img
                    style="
                      width: 20px;
                      border-radius: 50px;
                      margin: 0 20px 0 40px;
                    "
                    src="../assets/img/user.png"
                    alt=""
                  />
                  <!-- ../assets/img/bgImg.png -->
                  <span>{{ userName }}</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="personal"
                    >个人中心</el-dropdown-item
                  >
                  <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </nav>
      <!-- 个人中心 -->
      <!-- <div v-if="usershow">
                <div id="dialogBgdialogBg" @click="handleDialog"></div>
                <div class="user">
                    <ul>
                        <li style="border-bottom: 1px solid #6160DC;text-align: center;">
                            <h1 style="display: block; color: #fff; font-size: 14px;" v-if="type == 2"><span style="color: #6160DC;">用户名：</span>{{ip}}</h1>
                            <h1 style="display: block; color: #fff; font-size: 14px;" v-else><span style="color: #6160DC;">用户名：</span>{{userName}}</h1>
                        </li>
                        <li></li>
                        <li>
                            <h1>
                                <img src="../assets/imgs/usercenter.png" alt="">
                                个人中心
                            </h1>
                            <p @click="editPwd" v-if="type == 1 || type == 3">修改密码</p>
                            <p @click="registered" v-if="type == 2">注册账号</p>
                            <p @click="personal_login" v-if="type == 2">登录账号</p>
                            <p @click="logout">退出</p>
                        </li>
                    </ul>
                </div>
            </div> -->
    </div>

    <!-- 修改密码的弹窗部分 -->
    <div class="dialog_con" v-if="dialogFlag">
      <div id="dialogBg" @click="handleDialog"></div>
      <div class="dialog">
        <div class="dialogIco">
          <i class="iconfont icon-miaoshu miaoshu"></i>
        </div>
        <div class="dialogTop">
          <i
            class="iconfont icon-guanbi claseDialogBtn"
            @click="handleDialog"
          ></i>
        </div>
        <div class="dianlog_wrap">
          <ul class="editInfos">
            <li>
              <label>
                <span class="input_name">
                  <font color="#ff0000">*</font>原密码：
                </span>
                <input
                  type="password"
                  v-model.trim="oldPwd"
                  name
                  required
                  class="ipt"
                  @focus="msg = ''"
                  autocomplete="off"
                />
                <i class="iconfont icon-yiliaohangyedeICON- oldpwd"></i>
              </label>
            </li>
            <li>
              <label>
                <span class="input_name">
                  <font color="#ff0000">*</font>新密码：
                </span>
                <input
                  type="password"
                  v-model.trim="newPwd"
                  name
                  required
                  class="ipt"
                  @focus="msg = ''"
                  autocomplete="off"
                />
                <i class="iconfont icon-querenmima newpwd"></i>
              </label>
            </li>
            <li>
              <label>
                <span class="input_name">
                  <font color="#ff0000">*</font>确认密码：
                </span>
                <input
                  type="password"
                  v-model.trim="reNewPwd"
                  name
                  required
                  class="ipt"
                  @focus="msg = ''"
                  autocomplete="off"
                />
                <i class="iconfont icon-querenmima newpwd"></i>
              </label>
            </li>

            <li class="tips">
              <span v-if="msg">* </span>
              {{ msg }}
            </li>
            <li>
              <input
                type="button"
                value="确认提交"
                class="submitBtn"
                @click="editBtn"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "", // 导航选中状态
      search_content: "", // 检索框输入的内容
      usershow: false, //用户个人中心

      /* -------------- 修改密码 ------------ */
      dialogFlag: false, // 是否显示修改密码的弹窗
      oldPwd: null, // 旧密码
      newPwd: null, // 新密码
      reNewPwd: null, // 确认密码
      msg: "", // 提示内容
      /* -------------- 登录 ------------- */
      userName: "", // 用户的名称
      ip: "", // ip登录地址
      useruser: 0, //账号登录
      siteName: "", // 机构名称
      loginType: null, // 登录方式
      visible: false,
    };
  },
  watch: {
    $route(to, from) {
      if (
        to.name == "index" ||
        to.name == "ch_search" ||
        to.name == "search" ||
        to.name == "project"
      ) {
        this.active = to.name;
        // console.log(this.active);
      } else if (to.path.indexOf("caseBase") !== -1) {
        this.active = "search";
        // console.log(to.path.indexOf("caseBase"))
      }
      if (to.name == "ch_caseDetail") {
        this.active = "ch_search";
      } else if (to.name == "caseDetail") {
        this.active = "search";
      }
    },
  },
  created() {
    this.ip = this.$cookies.getCookie("ip");
    this.siteName = this.$cookies.getCookie("siteName");
    this.userName = this.$cookies.getCookie("userName");
    this.loginType = this.$cookies.getCookie("type");
    this.token = this.$cookies.getCookie("token");
  },
  methods: {
    aa() {
      //   console.log("a");
      // this.visible  = true;
    },
    removeActive() {
      //   console.log("c");
      //   this.visible = false;
    },
    prompt() {
      this.$alert("暂未开通此功能，敬请期待~", "", {
        confirmButtonText: "确定",
      });
    },
    //
    inputValue(value) {},
    // 普通检索
    commonSearch() {
      let logic_search = "";
      let key_search = "";
      let val_search = "";
      if (this.search_content) {
        logic_search = "or";
        key_search = "theme";
        val_search = this.search_content;
        this.refine = {};
      }
      localStorage.setItem("searchType", 1);
      this.$router.push({
        name: "search",
        query: {
          logic: logic_search,
          key: key_search,
          val: val_search,
          refine: JSON.stringify(this.refine),
        },
      });
      this.search_content = "";
    },
    // 跳转登录页
    goLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    // 注册账号、退出登录
    selectDropdown(command) {
      // 注册个人账号
      if (command == "register") {
        // ip 登录
        // this.$http({
        //     method: "POST",
        //     url: "iplogin",
        //     data:{}
        // }).then((res) => {
        //     // IP登录成功
        //     this.$cookies.loginSetCookie(res.data);
        //     localStorage.setItem('ipdl','try')
        this.$router.push({
          path: "/register",
        });
        // });

        // 退出登录
      } else if (command == "logOut") {
        console.log(11);
        this.$router.push({
          path: "/login",
        });
        localStorage.setItem("ipdl", "");
        this.$cookies.logoutClearCookie();
      } else if (command == "personal") {
        this.$router.replace({
          path: "/personal",
        });
      }
    },
    // 登录账号
    personal_login() {
      this.$router.push({
        path: "/login",
        query: {
          loginType: "personalAccount",
        },
      });
    },

    // 个人中心展示
    userif() {
      if (this.usershow === false) {
        this.usershow = true;
      } else if (this.usershow === true) {
        this.usershow = false;
      }
    },
    // 点击了修改密码,显示弹窗
    editPwd() {
      this.oldPwd = null;
      this.newPwd = null;
      this.reNewPwd = null;
      this.msg = "";
      this.dialogFlag = true;
    },
    // 关闭弹窗
    handleDialog() {
      this.dialogFlag = false;
      this.usershow = false;
    },
    // 提交修改密码
    editBtn() {
      if (!this.oldPwd) {
        this.msg = "请输入原密码";
      } else if (!this.newPwd) {
        this.msg = "请输入新密码";
      } else if (!this.reNewPwd) {
        this.msg = "请再次输入新密码";
      } else if (this.newPwd != this.reNewPwd) {
        this.msg = "两次密码不一致";
      } else {
        this.$http
          .post("EditPass", {
            old_pass: this.oldPwd,
            new_pass: this.newPwd,
            con_pass: this.reNewPwd,
          })
          .then((res) => {
            this.dialogFlag = false;
            this.$message({
              message: res.message + "请重新登录",
              type: "success",
            });
            var userType = this.$cookies.getCookie("type");
            if (userType == 3) {
              // 机构子用户修改密码成功后重新登录
              this.personal_login();
            } else {
              // 机构账号修改密码成功后退出重新登录
              this.logout();
            }
          })
          .catch(
            (error) => console.log(error) //请求失败返回的数据
          );
      }
    },
  },
};
</script>

<style lang="less">
.active {
  color: #6160dc;
  font-weight: 700;
  // color: #666;
  font-size: 18px;
  line-height: 65px;
  cursor: pointer;
  padding-bottom: 5px;
  border-bottom: 4px solid #6160dc;
}
.active_ {
  color: #6160dc;
  //   font-weight: 700;
  // color: #666;
  //   font-size: 18px;
  //   line-height: 65px;

  cursor: pointer;
  //   padding-bottom: 5px;
  //   border-bottom: 4px solid #6160dc;
}
.nav_wrap .el-popover {
  width: calc(100% - 30%);
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
  color: #ffffff;
}
.el-menu.el-menu--horizontal {
  border-bottom: solid 1px transparent;
}
.el-menu {
  background-color: transparent;
}
.demo-drawer__content {
  text-align: left;
  ul li {
    padding-left: 25px;
    height: 45px;
    border-bottom: 1px solid rgb(241, 241, 241);
    line-height: 45px;
    a {
      color: #000;
      font-size: 16px;
    }
  }
  li:hover {
    cursor: pointer;
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>

<style lang="less" scoped>
.el-popover {
  max-width: 80%;
  min-width: 800px;
  right: 0 !important;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #ddd;
}
.user:hover {
  cursor: pointer;
}
.user {
  box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.349019607843137);
  border-radius: 0px 0px 5px 5px;
  display: block;
  position: absolute;
  top: 65px;
  right: 1%;
  width: 137px;
  min-height: 100px;
  background: #262626;
  z-index: 999999999;
  padding-bottom: 5px;
  h1 {
    color: #6160dc;
    display: flex;
    justify-items: center;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 5px;
    font-size: 14px;
  }
  li {
    padding: 0 15px;
  }
  ul li p {
    color: #fff;
    padding-left: 37px;
    line-height: 25px;
    font-size: 12px;
  }
  ul li p:hover {
    color: #6160dc;
  }
  ul li h1 img {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}

body {
  width: 100%;
}
nav {
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 2%;
  // border-bottom: 1px solid #ddd;
  .left_nav {
    font-size: 30px;
    display: flex;
    justify-content: space-between;
    .nav_font {
      margin-left: 60px;
      //   min-width: 250px;
      min-width: 170px;
      display: flex;
      justify-content: space-between;
      .index_active {
        color: #6160dc;
        border-bottom: 4px solid #6160dc;
      }
      .nav_item {
        font-weight: 600;
        color: #666;
        font-size: 18px;
        line-height: 65px;
        cursor: pointer;
      }
      .nav_item {
        font-weight: 600;
        color: #666;
        font-size: 18px;
        line-height: 65px;
        cursor: pointer;
      }
      .nav_item_ {
        // font-weight: 700;
        color: #666;
        font-size: 18px;
        line-height: 30px;
        cursor: pointer;
        // padding: 0 0 4px 0;
      }
      .nav_item_:hover {
        color: #6160dc;
      }
      .nav_item:hover {
        color: #6160dc;
      }
    }
  }
  .middle_search {
    display: flex;
    align-items: center;
    width: 40%;
    padding: 0 20px;
    margin: 0 20px;
    // border: 1px solid #d1d1d1;
    background-color: #f2f2f2;
    border-radius: 50px;
    /deep/ .el-input--suffix .el-input__inner {
      border: none;
      background-color: #f2f2f2;
    }
  }
  @media screen and (max-width: 1400px) {
    .middle_search {
      display: flex;
      align-items: center;
      width: 20%;
      padding: 0 20px;
      margin: 0 20px;
      // border: 1px solid #d1d1d1;
      background-color: #f2f2f2;
      border-radius: 50px;
      /deep/ .el-input--suffix .el-input__inner {
        border: none;
        background-color: #f2f2f2;
      }
    }
  }
  .right_personal {
    .loginStatus {
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        margin-right: 40px;
      }
      .orgLogin {
        // 机构登录
        font-size: 14px;
        display: flex;
        align-items: center;
        .welcome {
          color: #666;
          font-weight: 500;
          letter-spacing: 2px;
        }
        .line {
          width: 2px;
          height: 20px;
          background-color: #999;
          margin: 0 20px;
        }
        span {
          margin-left: 10px;
          // color: #6160DC;
          font-weight: 500;
        }
        img {
          cursor: pointer;
        }
      }
    }
    display: flex;
    justify-content: space-between;
    .login_btn {
      width: 150px;
      color: #fff;
      background-color: #6160dc;
      border-radius: 50px;
    }
    .right_con {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .personal {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
.nav_logo {
  display: flex;
  height: 65px;
  align-items: center;
  float: left;
  color: #6160dc;
  font-size: 22px;
  font-weight: 700;
}
.nav_logo img {
  width: 135px;
  cursor: pointer;
  display: inline-block;
}
nav .nav_item:hover {
  color: #6160dc;
}

#dialogBgdialogBg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
#dialogBg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  width: 400px;
  height: 300px;
  margin: auto;
  border: 1px solid #ccc;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  box-shadow: 3px 2px 4px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 3px 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}
.dialogTop {
  width: 90%;
  height: 44px;
  margin: 0 auto;
  border-bottom: 1px dotted #ccc;
  letter-spacing: 1px;
  padding: 10px 0;
  text-align: right;
}
.dialogIco {
  position: absolute;
  top: -25px;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  border-radius: 50%;
  background-color: #6160dc;
}
.miaoshu {
  line-height: 58px;
  text-align: center;
  font-size: 27px;
  color: #fff;
}
.editInfos {
  padding: 15px 0;
}
.editInfos li {
  width: 100%;
  margin: 8px auto auto;
  text-align: center;
}
label {
  position: relative;
  text-align-last: justify;
}
.input_name {
  display: inline-block;
  width: 84px;
  text-align: left;
}
i {
  position: absolute;
  right: 10px;
  top: -5px;
  font-size: 24px;
  color: #999;
}
.claseDialogBtn {
  top: 10px;
  right: 20px;
  font-size: 22px;
}
.newpwd {
  top: -7px;
}
.ipt {
  height: 35px;
  width: 210px;
  border: 1px solid #ccc;
  padding: 5px 36px 0 5px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  box-shadow: 0 0 3px #ccc inset;
  -webkit-box-shadow: 0 0 3px #ccc inset;
}
.ipt:focus {
  outline: none;
  border-color: #66afe9;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset,
    0 0 8px rgba(102, 175, 233, 0.6);
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset,
    0 0 8px rgba(102, 175, 233, 0.6);
}
.submitBtn {
  display: inline-block;
  width: 100px;
  height: 40px;
  line-height: 30px;
  margin-top: 10px;
  border-radius: 5px;
  text-align: center;
  font-family: "微软雅黑", "microsoft yahei";
  color: #000;
  background-color: #6160dc;

  cursor: pointer;
  box-shadow: 0 -3px 0 #6160dc inset;
  -webkit-box-shadow: 0 -3px 0 #6160dc inset;
  -webkit-border-radius: 5px;
}
font {
  margin-right: 5px;
  vertical-align: middle;
}
.editInfos .tips {
  // margin-top: 20px;
  // margin-left: -88px;
  font-size: 12px;
  vertical-align: middle;
  color: red;
  float: left;
  height: 16px;
}
.tips span {
  vertical-align: -3px;
}
.username {
  color: #389eac;
  margin-right: 5px;
  font-weight: 700;
}
// .bookcase {
//     padding: 20px 20px;
//     background: url("../assets/imgs/vip-nav-normal.png") no-repeat;
//     background-size: 100%;
// }
.nav_item_:hover {
  color: #6160dc;
}
.go_journal {
  color: #606266;
}
.go_journal:hover {
  color: #6160dc;
}
</style>



// WEBPACK FOOTER //
// src/components/comHeader.vue